import { createProjectSelectQuery } from 'util/createProjectSelectQuery';

import { serializeError } from 'shared/utils/redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { companyRepository } from 'container/companyRepository';
import { CompanyModel } from 'api/dto/Company.dto';
import { CompanyApi } from 'api/CompanyApi';
import { ProjectModel } from 'api/dto/Project.dto';
import { STORE_NAME } from 'reduxStore/company/initialState';
import { selectCurrentCompanyId, selectCurrentKind } from 'reduxStore/project/projectSelector';
import { selectCurrentCircle } from 'reduxStore/circles/selectors';

export const fetchCompanyList = createAsyncThunk<CompanyModel[]>(
  `${STORE_NAME}/fetchCompanyList`,
  async () => companyRepository.list(),
  { serializeError },
);

export const fetchCompanyProjectList = createAsyncThunk<ProjectModel[]>(
  `${STORE_NAME}/fetchCompanyProjectList`,
  async (_, { getState }) => {
    const companyId = selectCurrentCompanyId(getState());
    const kind = selectCurrentKind(getState());
    const currentCircle = selectCurrentCircle(getState());
    const query = createProjectSelectQuery(companyId, kind, currentCircle?.id);

    return companyRepository.projectList(query);
  },
  { serializeError },
);

export const fetchCompanyProfile = createAsyncThunk<CompanyApi.CompanyProfile>(
  `${STORE_NAME}/fetchCompanyProfile`,
  async (_, { getState }) => {
    const companyId = selectCurrentCompanyId(getState());
    return companyRepository.getProfile(companyId);
  },
  { serializeError },
);

export const updateCompanyProfile = createAsyncThunk<void, CompanyApi.CompanyProfile>(
  `${STORE_NAME}/updateCompanyProfile`,
  async (profile, { getState }) => {
    const companyId = selectCurrentCompanyId(getState());
    return companyRepository.updateProfile(companyId, profile);
  },
  { serializeError },
);

export const fetchMergeConnections = createAsyncThunk<CompanyApi.MergeConnection[]>(
  `${STORE_NAME}/fetchMergeConnections`,
  async (_, { getState }) => {
    const companyId = selectCurrentCompanyId(getState());
    return companyRepository.getMergeConnections(companyId);
  },
  { serializeError },
);
